import { MarketingLayout } from "@/components/MarketingLayout";
import { PageHeader } from "@/components/ui/PageHeader";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { FeatureGrid } from "@/components/landing/FeatureGrid";
import { EthicsStrip } from "@/components/landing/EthicsStrip";

export default function HowItWorksPage() {
  return (
    <MarketingLayout>
      <PageHeader
        title="How Reputely"
        accent="actually works."
        subtitle="We read every monitored review, surface policy issues, and prepare the next step. Managed filing requires verified Brand Registry access."
      />
      <HowItWorks />
      <FeatureGrid />
      <EthicsStrip />
    </MarketingLayout>
  );
}
